export default {
    symbolsKeyValue: "Abc",
    layout: [
        ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
        ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
        ["z", "x", "c", "v", "b", "n", "m"]
    ],
    specialKeysLayout: ["ā", "ē", "ī", "ū", "č", "ģ", "ķ", "ļ", "ņ", "š", "ž"],
    specialKeysLabel: "āčš"
};
